/// <amd-module name="Wit/WorkItemRequirementsLinks/Components/StoryboardLinkForm" />
import * as React from "react";
import { useState } from "react";
import { format } from "VSS/Core/Util/String";
import { useDebouncedSubscription, useObservable } from "VSS/Core/Observable";
import { TextField } from "VSSUI/TextField";
import { FormItem } from "VSSUI/FormItem";
import { ArtifactsUpdatedCallback } from "Wit/WorkItemLinksRegistration/IRegisteredLinkTypeService";
import * as Resources from "Wit/WorkItemRequirementsLinks/Resources";
import { createStoryboardDisplayData, isValidStoryboardUrl } from "../StoryboardUtils";

interface IStoryboardLinkFormProps {
    onArtifactsUpdated: ArtifactsUpdatedCallback;
}

export function StoryboardLinkForm({ onArtifactsUpdated }: IStoryboardLinkFormProps) {
    const [storyboardUrl, setStoryboardUrl] = useObservable<string>("");
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useDebouncedSubscription(storyboardUrl, 500, newText => {
        if (newText === "") {
            onArtifactsUpdated([]);
            setErrorMessage(Resources.ErrorMissingStoryboardLink);
            return;
        }

        if (!isValidStoryboardUrl(newText)) {
            onArtifactsUpdated([]);
            setErrorMessage(format(Resources.ErrorInvalidStoryboardLink, newText));
            return;
        }

        onArtifactsUpdated([createStoryboardDisplayData(newText)]);
        setErrorMessage(null);
    }, []);

    return (
        <FormItem label={Resources.StoryboardLocationLabel} error={!!errorMessage} message={errorMessage}>
            <TextField value={storyboardUrl} onChange={(e, text) => setStoryboardUrl(text)} />
        </FormItem>
    );
}
